// The Attendance page's badge strip: only the badges the child earned. A
// child with none gets none; the page once filled the gap with demo badges,
// so every family appeared to have earned them.

const achieved = (iso) =>
  `Achieved: ${new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })}`;

/** Earned badges -> carousel cards. `icons` stand in for a badge with no art. */
export const attendanceBadges = (earned, icons = []) =>
  (earned || []).map((badge, index) => ({
    title: badge.name || badge.title,
    subtitle: badge.earned_at ? achieved(badge.earned_at) : badge.description,
    icon:
      badge.icon_url ||
      badge.image_url ||
      (icons.length ? icons[index % icons.length] : undefined),
    active: index === 0,
  }));
